import React from "react";
import "../styles/ContactModal.css";

const ContactModal = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <h2>Kontaktiere Uns</h2>
                <p><strong>Telefon:</strong> +49 8445 929 5636</p>
                <p><strong>Whatsapp:</strong>{' '}
                    <a href="https://wa.me/4984459295636" target="_blank">Nachricht über WhatsApp senden</a>
                </p>
                <p><strong>Email:</strong>{' '}
                    <a href="mailto:info@hundefriseur-scheyern.de">info@hundefriseur-scheyern.de</a></p>
                <button className="close-button" onClick={onClose}>Schließen</button>
            </div>
        </div>
    );
};

export default ContactModal;
